import { Line } from 'react-chartjs-2';

const complianceData = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  datasets: [{
    label: 'Compliance Score',
    data: [85, 87, 86, 89, 92, 90],
    borderColor: 'rgb(79, 70, 229)',
    tension: 0.4,
  }],
};

const teamAssignments = [
  { role: 'Crisis Manager', assigned: 'John Smith', status: 'active' },
  { role: 'Technical Lead', assigned: 'Sarah Johnson', status: 'active' },
  { role: 'Communications Lead', assigned: 'Mike Brown', status: 'standby' },
  { role: 'Legal Advisor', assigned: 'Emma Davis', status: 'active' },
];

export default function Governance() {
  return (
    <div className="space-y-6 mt-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Regulatory Compliance Status</h3>
          <div className="h-64">
            <Line data={complianceData} />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Crisis Team Assignments</h3>
          <div className="space-y-4">
            {teamAssignments.map((assignment) => (
              <div key={assignment.role} className="flex items-center justify-between">
                <div>
                  <h4 className="font-medium">{assignment.role}</h4>
                  <p className="text-sm text-gray-600">{assignment.assigned}</p>
                </div>
                <span
                  className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    assignment.status === 'active'
                      ? 'bg-green-100 text-green-800'
                      : 'bg-yellow-100 text-yellow-800'
                  }`}
                >
                  {assignment.status}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium mb-4">Incident Reporting Workflow</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Detection & Triage</h4>
            <div className="mt-2">
              <p className="text-sm text-gray-600">Average response time: 15 mins</p>
              <div className="mt-2 flex items-center">
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-green-500 h-2 rounded-full" style={{ width: '92%' }} />
                </div>
                <span className="ml-2 text-sm font-medium">92%</span>
              </div>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Investigation</h4>
            <div className="mt-2">
              <p className="text-sm text-gray-600">Average duration: 4 hours</p>
              <div className="mt-2 flex items-center">
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-green-500 h-2 rounded-full" style={{ width: '88%' }} />
                </div>
                <span className="ml-2 text-sm font-medium">88%</span>
              </div>
            </div>
          </div>
          <div className="border rounded-lg p-4">
            <h4 className="font-medium text-gray-900">Resolution</h4>
            <div className="mt-2">
              <p className="text-sm text-gray-600">Average time to resolve: 12 hours</p>
              <div className="mt-2 flex items-center">
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-green-500 h-2 rounded-full" style={{ width: '85%' }} />
                </div>
                <span className="ml-2 text-sm font-medium">85%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}